class DynamicTexts extends HTMLElement {
  connectedCallback() {
    this.txts = this.querySelector(".rotation__animate-text")?.children;
    if (!this.txts || this.txts.length === 0) return;

    this.txtsLen = this.txts.length;
    this.index = 0;
    this.textInTimer = 2000;
    this.textOutTimer = 1800;

    this.animateText();
  }

  animateText() {
    for (let i = 0; i < this.txtsLen; i++) {
      this.txts[i].classList.remove("text-in", "text-out");
    }

    this.txts[this.index].classList.add("text-in");

    setTimeout(() => {
      this.txts[this.index].classList.add("text-out");
    }, this.textOutTimer);

    setTimeout(() => {
      this.index = (this.index + 1) % this.txtsLen;
      this.animateText();
    }, this.textInTimer);
  }
}

customElements.define("dynamic-texts", DynamicTexts);
